/* size-fit-note v9.1 · Bruno · 06.10.2026 — נוסח מידה שאזלה · v9 — חלונית לפי מורג: המלצה ישירה בלי שאלה, 2 כפתורים ברורים */
(function () {
  if (window.__sizeFitNote) return;
  window.__sizeFitNote = true;

  var SRC = /(ההמלצה\s*)?(מתבצעת|מבוססת)\s+(לאחר|על)\s+מדידות/;
  var DIR = /(מידה קטנה|מידה גדולה|מידה אחת (?:מעל|פחות|מתחת)|מידה (?:מעל|פחות|מתחת))/g;
  var SAME = /(מידה למידה|המידה (?:אותה|שאת) (?:את )?רגילה לנעול)/g;
  var TIPS = /(את הגדולה מביניהן|את הקטנה מביניהן|לא מתאים למבנה רגל רחב)/g;
  var UNUSUAL = /(מידה קטנה|מידה גדולה|מעל|פחות|מתחת)/;

  // ---------- תצוגת ההמלצה ----------
  function addText(parent, text, re) {
    text.split(re).forEach(function (part, i) {
      if (!part) return;
      if (i % 2 === 1) {
        var b = document.createElement('strong');
        b.textContent = part;
        parent.appendChild(b);
      } else {
        parent.appendChild(document.createTextNode(part));
      }
    });
  }

  function highlight(p, text) {
    DIR.lastIndex = 0;
    var main = DIR.test(text) ? DIR : SAME;
    var combined = new RegExp(main.source.slice(0, -1) + '|' + TIPS.source.slice(1), 'g');
    addText(p, text, combined);
  }

  function enhance(note) {
    var body = note.querySelector('.size-fit-note__body');
    if (!body || body.classList.contains('is-ready')) return;
    var raw = body.textContent;
    var shift = note.dataset.shift;
    note.__shift = shift === '1' ? 1 : shift === '-1' ? -1 : 0;
    note.__unusual = shift === '' ? UNUSUAL.test(raw) : note.__shift !== 0;
    try { note.__sizes = JSON.parse(note.dataset.sizes || '{}'); } catch (e) { note.__sizes = {}; }
    var segs = raw.split(/\s*[|*\n]+\s*|\.\s+/)
      .map(function (s) { return s.replace(/^[\s\-–·,]+|[\s\-–·,]+$/g, ''); })
      .filter(Boolean);
    if (!segs.length) return;
    var lines = segs.filter(function (s) { return !SRC.test(s); });
    var src = segs.filter(function (s) { return SRC.test(s); });
    if (!lines.length) { lines = src; src = []; }
    body.textContent = '';
    lines.forEach(function (s) {
      var p = document.createElement('p');
      p.className = 'size-fit-note__line';
      highlight(p, s);
      body.appendChild(p);
    });
    if (src.length) {
      var f = document.createElement('p');
      f.className = 'size-fit-note__src';
      f.textContent = src.join(' · ');
      body.appendChild(f);
    }
    body.classList.add('is-ready');
  }

  function flash(note) {
    note.classList.remove('is-flash');
    void note.offsetWidth;
    note.classList.add('is-flash');
  }

  function enhanceAll() {
    document.querySelectorAll('size-fit-note').forEach(enhance);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhanceAll);
  else enhanceAll();

  // ---------- זיכרון "כבר אישרה" לכל דגם ----------
  var memo = {};
  function confirmed(id) {
    try { return memo[id] || sessionStorage.getItem('sfn-ok-' + id) === '1'; } catch (e) { return !!memo[id]; }
  }
  function setConfirmed(id) {
    memo[id] = true;
    try { sessionStorage.setItem('sfn-ok-' + id, '1'); } catch (e) {}
  }

  // ---------- חלונית אישור ----------
  var sheet, lastFocus, pending;

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text) n.textContent = text;
    return n;
  }

  function buildSheet() {
    sheet = document.createElement('div');
    sheet.className = 'sfn-sheet';
    sheet.hidden = true;
    sheet.innerHTML =
      '<div class="sfn-sheet__backdrop" data-sfn-act="close"></div>' +
      '<div class="sfn-sheet__panel" role="dialog" aria-modal="true" aria-labelledby="sfn-sheet-heading">' +
        '<button type="button" class="sfn-sheet__close" aria-label="סגירה" data-sfn-act="close">&times;</button>' +
        '<p class="sfn-sheet__heading" id="sfn-sheet-heading">רגע לפני שמוסיפים לסל</p>' +
        '<div class="sfn-sheet__note"></div>' +
        '<p class="sfn-sheet__question" hidden></p>' +
        '<div class="sfn-sheet__actions"></div>' +
      '</div>';
    document.body.appendChild(sheet);
    sheet.addEventListener('click', function (e) {
      var b = e.target.closest('[data-sfn-act]');
      if (!b || b.disabled) return;
      var act = b.getAttribute('data-sfn-act');
      if (act === 'update') return update(b);
      if (act === 'keep') return keep();
      if (act === 'pick') return cancel(true);
      if (act === 'close') return cancel(false);
    });
    document.addEventListener('keydown', function (e) {
      if (!sheet.hidden && e.key === 'Escape') cancel(false);
    });
  }

  function open(note, form) {
    if (!sheet) buildSheet();
    var fs = note.closest('fieldset');
    var pickedInput = fs && fs.querySelector('input[type="radio"]:checked');
    var picked = pickedInput ? pickedInput.value : '';
    var target = null;
    if (picked && note.__shift) {
      var t = String(parseFloat(picked) + note.__shift);
      var info = note.__sizes[t];
      if (info && info.a) target = { size: t, id: String(info.id) };
    }
    pending = { note: note, form: form, fs: fs, picked: picked, target: target };

    // נוסח מורג (06.10): המלצה ישירה ומותנית — לא מניחים שהמידה שסומנה היא המידה הרגילה של הלקוחה,
    // לכן: "אם המידה הרגילה שלך היא 38, בחרי 39". בלי כן/לא, בלי קישור "בחירת מידה אחרת" בתחתית.
    var dir = note.__shift;
    var heading = sheet.querySelector('.sfn-sheet__heading');
    var holder = sheet.querySelector('.sfn-sheet__note');
    var q = sheet.querySelector('.sfn-sheet__question');
    var actions = sheet.querySelector('.sfn-sheet__actions');
    holder.innerHTML = '';
    actions.innerHTML = '';
    var oldLink = sheet.querySelector('.sfn-sheet__link');
    if (oldLink) oldLink.remove();

    var suggested = (picked && dir) ? String(parseFloat(picked) + dir) : '';
    var exists = suggested && note.__sizes[suggested];

    if (dir) {
      heading.textContent = dir > 0 ? 'הדגם הזה קטן במידה' : 'הדגם הזה גדול במידה';
      holder.appendChild(el('p', 'sfn-sheet__rec', dir > 0
        ? 'מומלץ לבחור מידה אחת מעל המידה שאת נועלת בדרך כלל.'
        : 'מומלץ לבחור מידה אחת מתחת למידה שאת נועלת בדרך כלל.'));
      if (exists) {
        q.textContent = target
          ? 'אם המידה הרגילה שלך היא ' + picked + ', בחרי ' + suggested + '.'
          : 'אם המידה הרגילה שלך היא ' + picked + ', המידה המתאימה לך היא ' + suggested + ', אבל היא אזלה כרגע.';
      } else {
        q.textContent = '';
      }
    } else {
      // בלי כיוון מובנה — מציגים את טקסט ההמלצה עצמו (כמו בעמוד)
      heading.textContent = 'רגע לפני שמוסיפים לסל';
      var clone = note.cloneNode(true);
      clone.classList.remove('is-flash');
      holder.appendChild(clone);
      q.textContent = '';
    }
    q.hidden = !q.textContent;

    var first;
    function btn(cls, text, act) {
      var b = el('button', 'sfn-sheet__btn ' + cls, text);
      b.type = 'button';
      b.setAttribute('data-sfn-act', act);
      actions.appendChild(b);
      return b;
    }
    if (target) {
      first = btn('sfn-sheet__btn--primary', 'לבחור ' + target.size, 'update');
      btn('sfn-sheet__btn--secondary', 'להישאר עם ' + picked, 'keep');
    } else {
      first = btn('sfn-sheet__btn--primary', picked ? 'להמשיך עם ' + picked : 'הוספה לסל', 'keep');
      btn('sfn-sheet__btn--secondary', 'לבחירת מידה', 'pick');
    }

    lastFocus = document.activeElement;
    sheet.hidden = false;
    document.body.classList.add('sfn-lock');
    first.focus();
  }

  function close() {
    sheet.hidden = true;
    document.body.classList.remove('sfn-lock');
  }

  function submit(p) {
    setConfirmed(p.note.dataset.productId);
    var btn = p.form.querySelector('[type="submit"][name="add"], [type="submit"]');
    if (p.form.requestSubmit) p.form.requestSubmit(btn || undefined);
    else if (btn) btn.click();
  }

  function keep() {
    var p = pending; pending = null;
    close();
    if (p) submit(p);
  }

  function update(btn) {
    var p = pending;
    if (!p || !p.target) return;
    var input = Array.prototype.find.call(p.fs.querySelectorAll('input[type="radio"]'), function (i) { return i.value === p.target.size; });
    if (!input) return keep();
    btn.disabled = true;
    var label = input.id && document.querySelector('label[for="' + input.id + '"]');
    (label || input).click();
    var idInput = p.form.querySelector('[name="id"]');
    var start = Date.now();
    (function wait() {
      if (idInput && idInput.value === p.target.id) {
        pending = null;
        close();
        return submit(p);
      }
      if (Date.now() - start > 3000) {
        // המידה לא התעדכנה בזמן — לא מוסיפים לסל מידה לא נכונה; מחזירים לבחירת מידה.
        btn.disabled = false;
        return cancel(true);
      }
      setTimeout(wait, 100);
    })();
  }

  function cancel(goPick) {
    var p = pending; pending = null;
    close();
    if (!p) return;
    if (goPick) {
      (p.fs || p.note).scrollIntoView({ block: 'center', behavior: 'smooth' });
      flash(p.note);
    } else if (lastFocus && lastFocus.focus) {
      lastFocus.focus();
    }
  }

  // ---------- יירוט "הוספה לסל" בדגם חריג ----------
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !/\/cart\/add/.test(form.getAttribute('action') || '')) return;
    var scope = form.closest('.shopify-section, section, product-info, .product') || document;
    var note = scope.querySelector('size-fit-note');
    if (!note) return;
    enhance(note);
    if (!note.__unusual || confirmed(note.dataset.productId)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open(note, form);
  }, true);
})();